<template>
  <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="flex align-items-center gap-3">
        <layout-project />
      </div>

      <layout-header-menu />
    </div>
  </a-layout-header>
</template>

<script>
import { Layout } from 'ant-design-vue'
import LayoutHeaderMenu from './layout-header-menu.vue'
import LayoutProject from './layout-project.vue'

export default {
  components: {
    'layout-project': LayoutProject,
    'a-layout-header': Layout.Header,
    'layout-header-menu': LayoutHeaderMenu
  }
}
</script>
